import type { ActionIntent } from '../../services/agentDraftApi';

interface FunnelConfirmMessageProps {
  name: string;
  stages: string[];
  onConfirm: (params: { displayMessage: string; intent: ActionIntent }) => void;
  onSkip: (params: { displayMessage: string }) => void;
}

export function FunnelConfirmMessage({ name, stages, onConfirm, onSkip }: FunnelConfirmMessageProps) {
  return (
    <div
      data-testid="funnel-confirm-message"
      style={{
        marginTop: 8,
        padding: 12,
        background: '#f9fafb',
        borderRadius: 8,
        border: '1px solid #e5e7eb',
      }}
    >
      <p style={{ margin: '0 0 8px', fontWeight: 600, fontSize: 14, color: '#374151' }}>
        {name}
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
        {stages.map((stage, i) => (
          <span
            key={i}
            style={{
              padding: '3px 10px',
              background: '#ede9fe',
              color: '#6d28d9',
              borderRadius: 999,
              fontSize: 13,
              fontWeight: 500,
            }}
          >
            {stage}
          </span>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          onClick={() =>
            onConfirm({
              displayMessage: `Sim, pode criar o funil "${name}".`,
              intent: { type: 'create_funnel', payload: { name, stages } },
            })
          }
          data-testid="funnel-confirm-accept"
          style={{
            padding: '7px 14px',
            borderRadius: 8,
            border: 'none',
            background: '#8b5cf6',
            color: '#fff',
            fontWeight: 600,
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          Sim, criar assim
        </button>
        <button
          onClick={() => onSkip({ displayMessage: 'Não preciso de funil agora, pode pular.' })}
          data-testid="funnel-confirm-skip"
          style={{
            padding: '7px 14px',
            borderRadius: 8,
            border: '1px solid #e5e7eb',
            background: '#fff',
            color: '#6b7280',
            fontWeight: 500,
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          Não, pular
        </button>
      </div>
    </div>
  );
}
